import useAxios from '../hooks/useAxios';
import {SEXUAL_IMAGE_URL, SEXUAL_DIAGNOSE_URL} from './constants';

/**
 * Hook for interacting with the HeHealth API.
 *
 * @returns {Object} An object containing functions to interact with the API.
 */
export const useHeHealthApi = () => {
  const api = useAxios();

  /**
   * Posts an image URL to the HeHealth API for analysis.
   *
   * @param {FormData} formData - The FormData object containing the image URL.
   * @returns {Promise} A Promise that resolves when the request is complete.
   */
  const postMensSexualHealthImageUrl = formData =>
    api.post(SEXUAL_IMAGE_URL, formData, {
      headers: {'Content-Type': 'multipart/form-data'},
    });

  /**
   * Posts a diagnosis request to the HeHealth API based on a HeHealth object.
   *
   * @param {Object} hehealthObject - The HeHealth object for diagnosis.
   * @returns {Promise} A Promise that resolves when the request is complete.
   */
  const postMensSexualHealthDiagnose = hehealthObject => api.post(SEXUAL_DIAGNOSE_URL, hehealthObject);

  return {
    postMensSexualHealthImageUrl,
    postMensSexualHealthDiagnose,
  };
};
